/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PartnersIndexRouteImport } from './routes/partners.index'
import { Route as YardsYardIdRouteImport } from './routes/yards.$yardId'
import { Route as PartnersNewRouteImport } from './routes/partners.new'
import { Route as PartnersPartnerIdRouteImport } from './routes/partners.$partnerId'

const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIndexRoute = PartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartnersRoute,
} as any)
const YardsYardIdRoute = YardsYardIdRouteImport.update({
  id: '/yards/$yardId',
  path: '/yards/$yardId',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersNewRoute = PartnersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PartnersRoute,
} as any)
const PartnersPartnerIdRoute = PartnersPartnerIdRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => PartnersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/partners': typeof PartnersRouteWithChildren
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/yards/$yardId': typeof YardsYardIdRoute
  '/partners/': typeof PartnersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/yards/$yardId': typeof YardsYardIdRoute
  '/partners': typeof PartnersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/partners': typeof PartnersRouteWithChildren
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/yards/$yardId': typeof YardsYardIdRoute
  '/partners/': typeof PartnersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/partners'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/yards/$yardId'
    | '/partners/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/yards/$yardId'
    | '/partners'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/partners'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/yards/$yardId'
    | '/partners/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  PartnersRoute: typeof PartnersRouteWithChildren
  YardsYardIdRoute: typeof YardsYardIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/': {
      id: '/partners/'
      path: '/'
      fullPath: '/partners/'
      preLoaderRoute: typeof PartnersIndexRouteImport
      parentRoute: typeof PartnersRoute
    }
    '/yards/$yardId': {
      id: '/yards/$yardId'
      path: '/yards/$yardId'
      fullPath: '/yards/$yardId'
      preLoaderRoute: typeof YardsYardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/new': {
      id: '/partners/new'
      path: '/new'
      fullPath: '/partners/new'
      preLoaderRoute: typeof PartnersNewRouteImport
      parentRoute: typeof PartnersRoute
    }
    '/partners/$partnerId': {
      id: '/partners/$partnerId'
      path: '/$partnerId'
      fullPath: '/partners/$partnerId'
      preLoaderRoute: typeof PartnersPartnerIdRouteImport
      parentRoute: typeof PartnersRoute
    }
  }
}

interface PartnersRouteChildren {
  PartnersPartnerIdRoute: typeof PartnersPartnerIdRoute
  PartnersNewRoute: typeof PartnersNewRoute
  PartnersIndexRoute: typeof PartnersIndexRoute
}

const PartnersRouteChildren: PartnersRouteChildren = {
  PartnersPartnerIdRoute: PartnersPartnerIdRoute,
  PartnersNewRoute: PartnersNewRoute,
  PartnersIndexRoute: PartnersIndexRoute,
}

const PartnersRouteWithChildren = PartnersRoute._addFileChildren(
  PartnersRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PartnersRoute: PartnersRouteWithChildren,
  YardsYardIdRoute: YardsYardIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
